import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import ImageLibrary from './ImageLibrary'
import { setCurrentField, setCurrentSelectedImage } from './imageLibrarySlice'

const S = {
    Wrapper: styled.div`
        min-height: 75vh;
        margin-top: 20px;
    `
}

const ImageLibraryModal = ({ close, field }: { close: () => void, field: string }) => {
    const dispatch = useDispatch()
    const handleSelectImage = (url) => {
        dispatch(setCurrentField(field))
        dispatch(setCurrentSelectedImage(url))
        close()
    }

    return (
        <S.Wrapper>
            <ImageLibrary onSelectImage={handleSelectImage} />
        </S.Wrapper>
    )
}

export default ImageLibraryModal
